module.exports = __webpack_public_path__ + "img/bonus_symbol_1.a4f89b72.png";